import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Basic404Component } from './extrapages/basic404/basic404.component';
import { AppComponent } from './app.component';

const routes: Routes = [
  {
    path: ':nanoid',
    component: AppComponent,
  },
  // {
  //   path: 'business-card',
  //   loadChildren: () => import('./extrapages/business-card/business-card.module').then((m) => m.BusinessCardModule),
  // },
  {
    path: 'error/404',
    component: Basic404Component,
  },
  { path: '**', component: Basic404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
